import { createContext, type ReactNode, useContext } from 'react';

export type GaChartPreviewMeta = {
  messageId: string;
  itemId: string;
};

const GaChartPreviewMetaContext = createContext<GaChartPreviewMeta | null>(
  null
);

export function GaChartPreviewMetaProvider({
  messageId,
  itemId,
  children,
}: {
  messageId: string;
  itemId: string;
  children: ReactNode;
}) {
  return (
    <GaChartPreviewMetaContext.Provider value={{ messageId, itemId }}>
      {children}
    </GaChartPreviewMetaContext.Provider>
  );
}

export function useGaChartPreviewMeta(): GaChartPreviewMeta | null {
  return useContext(GaChartPreviewMetaContext);
}
